import React, { useEffect, useState } from 'react';
import { XRayContactsLineChart } from './XRayContactsLineChart';
import styles from './AnalyticsCharts.module.css';
import { AnalyticsFilterByDate } from '../../BotAnalytics/AnalyticsFilterByTime/AnalyticsFilterByDate';
import moment from 'moment';
import { Button } from '@mm/components';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { useSelector } from 'react-redux';
import { useBotAnalyticsCRUDActions } from '@mm/state/actions/BotAnalyticsCRUDActions';
import { useHistory } from 'react-router-dom';
import { BotBuilderRoutes } from '../../../../../../../routes/bot-builder-routes';
import { X_RAY_ANALYTICS_FILTER_TYPES } from '@mm/state/interfaces/botAnalytics';

export const DashboardXRayAnalytics = () => {
  const botId = useSelector(activeChatbotIdSelector);
  const [startDate, setStartDate] = useState<moment.Moment | null>(
    moment().subtract(30, 'days'),
  );
  const [endDate, setEndDate] = useState<moment.Moment | null>(moment());
  const [dateRangeMode, setDateRangeMode] = useState<string | null>(
    'Last 30 days',
  );
  const [busy, setBusy] = useState(false);

  const { retrieveXRayAnalytics, resetAllBotAnalytics } =
    useBotAnalyticsCRUDActions();

  const history = useHistory();

  const header = (
    <div className={styles.dashboardChartHeader}>
      <AnalyticsFilterByDate
        className={styles.calendar}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        dateRangeMode={dateRangeMode}
        setDateRangeMode={setDateRangeMode}
      />
      <Button
        color="secondary-blue"
        onClick={() =>
          history.push(
            BotBuilderRoutes.xrayAnalytics.getLink({ chatbotId: botId }),
          )
        }
        css={{ container: styles.secondaryButton }}
      >
        Go to X-Ray Pixel Analytics
      </Button>
    </div>
  );

  const fetchData = async () => {
    const formattedStartDate = startDate?.format('YYYY-MM-DD');
    const formattedEndDate = endDate?.format('YYYY-MM-DD');
    const params = {
      botId,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
    setBusy(true);
    await retrieveXRayAnalytics(
      X_RAY_ANALYTICS_FILTER_TYPES.contactsGathered,
      params,
    );
    setBusy(false);
  };

  useEffect(() => {
    fetchData();

    return () => {
      resetAllBotAnalytics();
    };
  }, [startDate, endDate]);

  return (
    <XRayContactsLineChart
      className={styles.dashboardChart}
      chartHeaderRightSide={header}
      busy={busy}
    />
  );
};
